import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

// An order number is not unique across stores, so the platform hands back the
// matches instead of guessing. Each row picks itself as the next lookup, by id.
export default function CandidatesTable({ candidates, onSelect }) {
  const { t } = useTranslation()
  const key = suffix => `natura_operations.picking.${suffix}`

  return (
    <div className="mt-3 overflow-x-auto">
      <table className="min-w-full text-sm text-gray-700">
        <thead>
          <tr className="text-left text-xs text-gray-500 uppercase">
            <th className="py-1 pr-4">{t(key('field_order_id'))}</th>
            <th className="py-1 pr-4">{t(key('field_order_number'))}</th>
            <th className="py-1 pr-4">{t(key('field_status'))}</th>
            <th className="py-1 pr-4">{t(key('field_store'))}</th>
            <th className="py-1" />
          </tr>
        </thead>
        <tbody>
          {candidates.map(candidate => (
            <tr key={candidate.order_id} className="border-t border-gray-200">
              <td className="py-1.5 pr-4 font-mono">{candidate.order_id}</td>
              <td className="py-1.5 pr-4 font-mono break-all">{candidate.order_number || '—'}</td>
              <td className="py-1.5 pr-4">{candidate.status || '—'}</td>
              <td className="py-1.5 pr-4">
                {candidate.store_name || '—'}
                {candidate.store_id ? <span className="text-gray-500"> (id {candidate.store_id})</span> : null}
              </td>
              <td className="py-1.5">
                <button
                  type="button"
                  onClick={() => onSelect(String(candidate.order_id))}
                  className="px-2 py-1 text-xs rounded border border-gray-300 bg-white hover:bg-gray-50"
                >
                  {t(key('use_this_one'))}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

CandidatesTable.propTypes = {
  candidates: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
}
